import { useState } from 'react'
import { BaseModal } from './BaseModal'

type Props = {
    isOpen: boolean
    handleClose: () => void
    handleLoad: (data: string) => void
}

export const ImportModal = ({ isOpen, handleClose, handleLoad }: Props) => {

    const [value, setValue] = useState('')

    const onChange = (val) => {
        setValue(val.target.value)
    }

    return (
        <BaseModal title="Load your game stats" isOpen={isOpen} handleClose={handleClose}>
            <p className="text-sm text-gray-300 mb-5 mt-5">
                Load your game stats from your note app
            </p>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" placeholder="Paste it here and then click load" onChange={(val) => onChange(val)}>
            </input>
            <button className="rounded-lg p-2 px-5 bg-violet-500 text-white font-bold mt-4" onClick={() => handleLoad(value)}>Load</button>
        </BaseModal>
    )
}